module.exports = __webpack_public_path__ + "img/title.b7ae5ba9.png";